import React from 'react';
import { Circle, Square } from 'lucide-react';
import { formatClock } from './demoToolkitUtils';

/**
 * Floating recording-active pill (top-right) shown while a demo session
 * is being captured. Calls `onStop` when the user clicks the stop chip.
 */
export default function DemoRecordingOverlay({ recording, elapsed, eventCount, onStop }) {
  if (!recording) return null;
  return (
    <div
      className="fixed top-4 right-4 z-[60] flex items-center gap-3 rounded-full border border-rose-300 bg-white/95 px-3 py-1.5 shadow-xl backdrop-blur"
      data-testid="demo-recorder-overlay"
    >
      <div className="flex items-center gap-1.5">
        <Circle className="h-2.5 w-2.5 fill-rose-500 text-rose-500 animate-pulse" />
        <span className="text-xs font-semibold uppercase tracking-wider text-rose-600">REC</span>
      </div>
      <span className="font-mono text-sm font-semibold text-slate-800 tabular-nums" data-testid="demo-recorder-clock">
        {formatClock(elapsed)}
      </span>
      <span className="text-[10px] text-slate-500" data-testid="demo-recorder-count">
        {eventCount} event{eventCount === 1 ? '' : 's'}
      </span>
      <button
        onClick={onStop}
        className="ml-1 flex items-center gap-1 rounded-full bg-rose-600 px-2.5 py-1 text-[11px] font-semibold text-white transition-colors hover:bg-rose-700"
        data-testid="demo-recorder-stop-btn"
        title="Stop recording and download captions"
      >
        <Square className="h-3 w-3 fill-white" />
        Stop
      </button>
    </div>
  );
}
